/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==============================zz============================================================ */


import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nData from './i18nData'
import i18nDpmData from './i18nDpmData'
import i18nBgiData from './i18nBgiData'
import i18nDeepData from './i18nDeepData'
import i18nPeopletreeData from './i18nPeopletreeData'
import i18nPciData from './i18nPciData'

import VueCookies  from 'vue-cookies'
Vue.use(VueCookies);
Vue.use(VueI18n)
let companyName="";
if(window.$cookies.get('companyName')){
    companyName=window.$cookies.get('companyName');
}else{
    companyName=window.$cookies.get('companyName');
}
export default new VueI18n(
  {
    locale: ((window.$cookies.get('locale') =='es')?'es':(window.$cookies.get('locale') =='fa')?'fa':'en'),
    fallbackLocale: 'en',
    messages: (window.$cookies.get('companyName')==='GALA.GAMES' )? i18nDpmData :(window.$cookies.get('companyName')==='BGI' )? i18nBgiData :(window.$cookies.get('companyName')==='Deep' )? i18nDeepData:(window.$cookies.get('companyName')==='Peopletree' )? i18nPeopletreeData:(window.$cookies.get('companyName')==='PCI' )? i18nPciData: i18nData
  })
